import { useState } from 'react'

import { Box, IconButton, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'

const useStyles = makeStyles((theme) => ({
  searchBox: {
    display: 'flex',
    '& button': {
      alignSelf: 'flex-end',
    },
  },
  searchSubBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  searchInputRoot: {
    minWidth: '200px',
    backgroundColor: 'white',
    maxWidth: '100%',
    margin: `${theme.spacing(1)}px 0`,
    [theme.breakpoints.up('sm')]: {
      margin: `0 ${theme.spacing(1)}px`,
    },
  },
}))
interface props {
  search: string
  prompt: string
  onSubmit: (search: string) => void
}

export const Search = ({ search, prompt, onSubmit }: props) => {
  const classes = useStyles()
  const [searchTerm, setSearchTerm] = useState(search)

  return (
    <form
      aria-labelledby="fln-search-form-label"
      id="fln-search-form"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit(searchTerm.trim())
      }}
      autoComplete="on"
    >
      <Box className={classes.searchBox}>
        <Box className={classes.searchSubBox}>
          <TextField
            className={classes.searchInputRoot}
            value={searchTerm}
            id="fln-FirstNameSearch"
            label={prompt}
            variant="outlined"
            size="small"
            autoComplete="given-name"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
        <IconButton
          color="primary"
          type="submit"
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      </Box>
    </form>
  )
}
